import React, { useEffect } from "react";
import { Button, Space, Popconfirm, Spin, Alert, Tag } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { useEnrollment } from "../contexts/EnrollmentContext";
import ScrollableTable from "../components/ScrollableTable";

const Enrollments: React.FC = () => {
  const {
    enrollments,
    loading,
    error,
    fetchEnrollments,
    approveEnrollment,
    rejectEnrollment,
    deleteEnrollment,
  } = useEnrollment();

  useEffect(() => {
    fetchEnrollments();
  }, []);

  const getStatusColor = (status: string) => {
    switch (status) {
      case "approved":
        return "success";
      case "rejected":
        return "error";
      default:
        return "warning";
    }
  };

  const columns = [
    {
      title: "User",
      dataIndex: ["user", "name"],
      key: "userName",
    },
    {
      title: "Email",
      dataIndex: ["user", "email"],
      key: "userEmail",
    },
    {
      title: "Phone",
      dataIndex: ["user", "phone"],
      key: "userPhone",
    },
    {
      title: "Country",
      dataIndex: ["user", "country"],
      key: "userCountry",
    },
    {
      title: "Course",
      dataIndex: ["course", "title", "en"],
      key: "courseTitle",
    },
    {
      title: "Level",
      dataIndex: ["course", "level"],
      key: "courseLevel",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: string) => (
        <Tag color={getStatusColor(status)}>{status.toUpperCase()}</Tag>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date: string) => new Date(date).toLocaleString(),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space>
          {record.status === "pending" && (
            <>
              <Popconfirm
                title="Are you sure you want to approve this enrollment?"
                onConfirm={() => approveEnrollment(record._id)}
                okText="Yes"
                cancelText="No"
              >
                <Button icon={<CheckOutlined />} type="primary" />
              </Popconfirm>
              <Popconfirm
                title="Are you sure you want to reject this enrollment?"
                onConfirm={() => rejectEnrollment(record._id)}
                okText="Yes"
                cancelText="No"
              >
                <Button icon={<CloseOutlined />} danger />
              </Popconfirm>
            </>
          )}
          <Popconfirm
            title="Are you sure you want to delete this enrollment?"
            onConfirm={() => deleteEnrollment(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h2>Enrollments</h2>
      </div>
      {error && (
        <Alert type="error" message={error} style={{ marginBottom: 16 }} />
      )}
      <Spin spinning={loading} tip="Loading enrollments...">
        <ScrollableTable
          rowKey="id"
          columns={columns}
          dataSource={enrollments}
        />
      </Spin>
    </div>
  );
};

export default Enrollments;
